//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'base-autocomplete-list',
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    selectedItem: {
      type: [Object, null],
      default: null,
    },
    selectedItems: {
      type: Array,
      default: () => ([]),
    },
    idProperty: {
      type: String,
      default: 'codeEn',
    },
    labelProperty: {
      type: String,
      default: 'name',
    },
    disabledProperty: {
      type: String,
      default: 'disabled',
    },
    typeAheadPointer: {
      type: Number,
      default: -1,
    },
    groupedItemsObject: {
      type: Object,
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    selectItem (item) {
      this.$emit('select', item);
    },
    switchItem (item) {
      if (this.isPickedOption(item[this.idProperty])) this.$emit('unselect', item);
      else this.$emit('select', item);
    },
    isSelectedOption (option, index) {
      return this.typeAheadPointer === index;
    },
    isPickedOption (id) {
      if (this.multiple) return this.selectedItems.map(item => item[this.idProperty]).includes(id);
      return this.selectedItem && this.selectedItem[this.idProperty] === id;
    },
    isPickedGroupOfOptions (groupName) {
      if (!groupName || !this.groupedItemsObject) return false;

      const groupOptions = this.groupedItemsObject[groupName];
      return groupOptions.every(option => this.isPickedOption(option[this.idProperty]));
    },
  },
};
